"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { Button, NutcakeLongLogo } from "@drpcrd/shared/ui";
import { cn } from "@drpcrd/utils";

/**
 * Sticky top navigation for creator profile pages.
 * Starts with a purple background (blending with the hero) with a white logo.
 * Once the user scrolls, it transitions to a white background with the dark logo.
 */
export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      aria-label="Site navigation"
      className={cn(
        "sticky top-0 z-50 flex w-full items-center justify-between p-2 transition-all duration-300 motion-reduce:transition-none",
        scrolled ? "bg-white" : "bg-[#472695]",
      )}
    >
      <Link href="/" aria-label="Nutcake home">
        <NutcakeLongLogo
          fill={scrolled ? "#5e32c7" : "white"}
          className="h-3.5 w-auto shrink-0 sm:h-5.25"
        />
      </Link>
      <Button
        variant="filled"
        size="sm"
        as={Link}
        href="/contact"
        className="shrink-0 whitespace-nowrap"
      >
        Open in Nutcake
      </Button>
    </header>
  );
};
